<p>
  Executes the given spell’s automation as if it were immediately cast. Does not use a spell slot to cast the spell.
  This is usually used in features that cast spells using alternate resources.
  <avr-autodoc-link anchor="cast-spell"></avr-autodoc-link>
</p>

<!-- spell -->
<div class="auto-row">
  <span>Cast </span>

  <mat-form-field>
    <mat-label>Spell</mat-label>
    <mat-select [value]="spellToCast" (selectionChange)="onSpellSelectionChange($event)">
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Search"
                               noEntriesFoundLabel="No matches found."
                               ngModel
                               (ngModelChange)="updateSearchFilteredSpells($event)">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let spell of searchFilteredSpells" [value]="spell">
        {{spell.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <span> at level </span>

  <mat-form-field floatLabel="always" matTooltip="If a level is not provided, this defaults to the spell's level.">
    <mat-label>Spell Level</mat-label>
    <input matInput placeholder="(default level)" [(ngModel)]="effect.level" type="number" min="0" max="9">
  </mat-form-field>
</div>

<!-- spellcasting info -->
<div>
  <mat-checkbox [(ngModel)]="custom"
                (change)="onCustomChange(); changed.emit()"
                matTooltip="Whether to use the caster's default DC and attack modifier or the information defined here.">
    Override caster's spellcasting information
  </mat-checkbox>
</div>

<div *ngIf="custom" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center">
  <mat-form-field fxFlex>
    <input matInput placeholder="DC" class="text-monospace" (change)="changed.emit()" [(ngModel)]="effect.dc">
    <mat-icon matSuffix matTooltip="IntExpression - variables and functions allowed">
      calculate
    </mat-icon>
  </mat-form-field>

  <mat-form-field fxFlex>
    <input matInput
           placeholder="Spell Attack Bonus"
           class="text-monospace"
           (change)="changed.emit()"
           [(ngModel)]="effect.attackBonus">
    <mat-icon matSuffix matTooltip="IntExpression - variables and functions allowed">
      calculate
    </mat-icon>
  </mat-form-field>

  <mat-form-field fxFlex>
    <input matInput
           placeholder="Spellcasting Modifier"
           class="text-monospace"
           (change)="changed.emit()"
           [(ngModel)]="effect.castingMod">
    <mat-icon matSuffix matTooltip="IntExpression - variables and functions allowed">
      calculate
    </mat-icon>
  </mat-form-field>
</div>


<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left baseline">
  <mat-form-field fxFlex>
    <input matInput
           placeholder="Parent"
           class="text-monospace"
           (change)="changed.emit()"
           [(ngModel)]="effect.parent"
           matTooltip="If supplied, sets the added effect's parent to the given effect. This must be the same as another IEffect's save_as.">
  </mat-form-field>
</div>
